import React, { useContext, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { filter } from "lodash";
import { StatusBox } from "components";
import { Link } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import EmployeeContext from "contexts/EmployeeContext";

const RequestStatusBadge = ({ status }) => {
  const statusColors = {
    'PENDING': 'warning',
    'REJECTED': 'danger',
    'COMPLETED': 'success'
  };

  return (
    <StatusBox status={status} color={statusColors[status]}>
      <Trans>{status}</Trans>
    </StatusBox>
  );
};

const List = ({ client, limit = false, match }) => {
  const [requests, setRequests] = useState();
  const [viewAllRequests, setViewAllRequests] = useState(true);
  const { employee } = useContext(EmployeeContext);

  useEffect(
    () =>
      void (async () => {
        if (!employee) return;
        const requests = await client
          .get(`employees/${employee.id}/iqama-renewal-requests`)
          .get("data");

        const active = filter(requests, (i) => {
          return ['PENDING'].includes(i.status);
        });

        setRequests({
          active,
          all: requests,
        });
      })(),
    [employee]
  );

  return (
    <div className="d-print-none inv-table">
      <Card className="shadow-sm border my-2">
        <CardBody>
          <div className="row mb-3">
            <div className="col-6">
              <h5 className="d-print-none">
                <Trans>Iqama Renewal Requests</Trans>
              </h5>
            </div>
            <div className="col-6 text-right">
              <Link
                className="btn btn-primary btn-sm d-print-none"
                to={`/employee_payroll/${employee.id}/iqama-renewal-requests/new`}
              >
                <Trans>New Iqama Renewal Request</Trans>
              </Link>
            </div>
          </div>

          <div className="row">
            <Button
              className="p-1 mb-2 btn btn-secondary"
              onClick={() => setViewAllRequests(!viewAllRequests)}
            >
              <Trans>
                View {viewAllRequests ? "Active" : "All"} Requests
              </Trans>
            </Button>
            <table className="table table-striped employee-holiday-table">
              <thead>
                <tr>
                  <th className="font-weight-semibold p-2">
                    <Trans>Expiry Date</Trans>
                  </th>
                  <th className="font-weight-semibold p-2">
                    <Trans>Notes</Trans>
                  </th>
                  <th className="font-weight-semibold p-2">
                    <Trans>Requested At</Trans>
                  </th>
                </tr>
              </thead>
              <tbody className="small">
                {requests && requests[viewAllRequests ? "all" : "active"]
                  .slice(0, limit || (requests &&requests[viewAllRequests ? "all" : "active"].length))
                  .map((request) => (
                    <tr key={request.id}>
                      <td className="p-2">
                        {request.expiry_date}
                      </td>
                      <td className="p-2">
                        {request.employee_notes || '-'}
                      </td>
                      <td className="p-2">
                        {request.requested_at}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            
            {requests && requests[viewAllRequests ? "all" : "active"].length === 0 && (
              <div className="text-center p-3 w-100">
                <Trans>No requests found</Trans>
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default List;
